import React, { useState } from 'react'
import { FaSearch } from 'react-icons/fa'

import './coinsearch_styles/searchbar.css'

export default function CoinSearchbar({ setSearchResults, data }) {

  const [input, setInput] = useState("");

  const handleChange = (value: any) => {
    setInput(value)
    let searchResults = data.filter((item: any) =>
      item.label.toLowerCase().includes(value.toLowerCase())
    );
    searchResults = searchResults.length > 0 ? searchResults : data;
    setSearchResults(searchResults);
  }

  return (
    <div className='input-wrapper'>
      <FaSearch id='search-icon' />
      <input className='search_input' type="text" value={input} onChange={(e) => handleChange(e.target.value)} placeholder='Search' />
    </div>
  )
}
